<!--订单.........-->
<template>
  <div>
    <div id="content">
      <div class="tabContent" style="display:block;">
        <ul class="searchUL outer">
          <li class="fr">
            <el-input placeholder="供应商单号或跟踪号，按enter键查询" v-model="tracknum" size="small" clearable style="width:260px;"
                      @keyup.enter.native="bindGrid" @clear="bindGrid">
            </el-input>
          </li>
          <li class="fr marginR">
            <el-date-picker size="small" style="width:210px;"
                            v-model="searchdatevalue"
                            type="daterange" :value-format="'yyyy-MM-dd'"
                            align="left" :unlink-panels="false"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
            </el-date-picker>
          </li>
          <li class="fr marginR">
            <el-select v-model="datetype" placeholder="请选择时间类别" size="small" style="width:115px;">
              <el-option
                :label="'按下单日期'"
                :value="'10'">
              </el-option>
              <el-option
                :label="'按发货日期'"
                :value="'20'">
              </el-option>
            </el-select>
          </li>
        </ul>
        <ul class="searchUL outer">
          <!--<li class="fl">-->
            <!--<a class="cgdBtn" href="javascript:void(0);" style="width: 100px;"  @click="showjingjiaOrderWeb">-->
              <!--镜架下单-->
            <!--</a>-->
          <!--</li>-->
          <li class="fr" style="width:200px;">
            <el-input placeholder="请输入订单号，enter键查询" v-model="searchdata" size="small" clearable
                      @keyup.enter.native="search" @clear="search">
              <el-button slot="append" icon="el-icon-search" @click="search" size="small"></el-button>
            </el-input>
          </li>
          <li class="fr marginR" style="width:115px;">
            <el-select v-model="statuses" @change="bindGrid" filterable size="small">
              <el-option
                v-for="(item,index1) in statusobj" :label="item.text"
                :value="item.value" :key="item.value">
              </el-option>
            </el-select>
          </li>
          <li class="fr marginR" style="width:250px;">
            <AutoCustomer @clear="clearCustomerName" :size="'small'"
                          @handleSelect="afterSelExternalDept"></AutoCustomer>
          </li>
          <li class="fr marginR" style="width:120px;">
            <el-select v-model="independentserial" @change="bindGrid('1')" filterable size="small">
              <el-option v-for="item in idd" :key="item.serialnum"
                         :label="item.dname"
                         :value="item.serialnum">
              </el-option>
            </el-select>
          </li>
        </ul>
        <!--搜索end-->
        <table class="titleTable">
          <tr>
            <th class="width_200 textLeft">
            </th>
            <th class="width_400 textLeft">订单详情</th>
            <th class="width_200">金额</th>
            <th class="width_200">
              订单状态
            </th>
            <th class="width_200">处理</th>
          </tr>
        </table>
        <!--titleTable end-->
        <div class="orderTable" :style="'height:'+tableHeight(156)+'px'">
          <div class="contentTable" v-for="(item,index) in tableData">
            <div class="head" v-if="item.isFirst">
              <p class="fl marginR-30 marginL-20">
                <!--<input type="checkbox" v-model="checkmodel" :value="item.erpserial"/>-->
                <label class="color-grey">{{item.htqd||item.adddate}}</label>
              </p>
              <p class="fl marginR-30 alignleft">
                <span class="color-grey ddNum ">订单号</span>
                <span class="marginR-30 erpserial1 ">{{item.erpserial}}  <span
                  v-html="getOrderType(item)"></span></span>
                <a href="javascript:void(0);"  @mouseenter="show1(item)"
                   @mouseleave="hide1(item)">
                  <span class="ellipsis">{{item.customername}}</span>
                  <!--<span class="tip "> <img class="iphone_icon" src="/static/img/iphone_icon.jpg"/>-->
                    <!--&lt;!&ndash;提示框&ndash;&gt;-->
                <!--<div class="sub-nav" v-show="false">-->
                  <!--<div class="Tipcontent">-->
                    <!--<ul>-->
                      <!--<li>联系人：{{item.linkman}}</li>-->
                      <!--<li>联系电话：{{item.linkmantel}}</li>-->
                      <!--<li>收货地址：{{item.deliveryaddress}}</li>-->
                      <!--<li>收货方式：{{item.deliverymode||""}}</li>-->
                    <!--</ul>-->
                  <!--</div>-->
                  <!--<s><i></i></s>-->
                <!--</div>-->
                    <!--&lt;!&ndash;提示框 end&ndash;&gt;-->
                 <!--</span>-->
                </a>
                <span style="margin-left:40px;">{{item.applybydname}}</span>
                <span style="margin-left:50px;">下单人：{{item.uname}}</span>
              </p>
              <div class="nick-name-box" v-if="item.status==350||item.status==500||item.status==810"
                   v-html="computedTime(item.htqd,item.jhjgrq,item.handleoverdate)">
              </div>
            </div>
            <!--head end-->
            <table class="mainTable">
              <tr>
                <td class="width_560"  :style="picture(item)"  rowspan="2">
                  <div v-for="(item1,index1) in item.jxcformdetailDOList"
                       :style="{height:'70px',paddingTop: '5px',paddingBottom: '5px',borderTop:index1>0?'1px solid #EEEEEE':'none'}">
                    <img style="width:70px;height:70px;margin-left: 10px;" :src="item1.imageUrl||''"
                         @error="imgError"/>
                    <p class="alignleft">
                      <span class="cp_title">{{item1.seedname}}</span>
                      <span>x {{item1.totalnumber||0}}</span>
                    </p>
                    <p style="margin-top: 10px;">
                      {{changePackageSize(item1.packagesize)}}
                    </p>
                  </div>
                </td>
                <td class="width_200 textCenter" style="vertical-align: middle;height: 56px" rowspan="2">
                  <div style="">
                    <p style="">
                      <span class="numtitle textR">金额：</span>
                      <span class="numbody textL">￥{{( (item.htje||0)+(item.discount||0) ) | numeric(2)}}</span>
                    </p>
                    <p style="">
                      <span class="numtitle textR">折扣：</span>
                      <span class="numbody textL">￥{{(item.discount||0)|numeric(2)}}</span>
                    </p>
                    <p style="">
                      <span class="numtitle textR">实收：</span>
                      <span class="numbody textL">
                        <span>￥{{(item.yfk||0)|numeric(2)}}</span>
                      <span class="color-yellow">{{item.status=='700'||item.status=='660'||item.status=='655'||item.status=='650'?'待退款':item.status=='750'?'已退款': item.status!='810'&&item.status!='820'&&((item.yfk>0&&!item.paymethod))?"未支付":"" }} </span></span>
                    </p>
                    <p class="color-yellow" v-if="item.isEnd">{{item.paymethod}}</p>
                  </div>
                </td>
                <td class="width_200 textCenter" :style="{verticalAlign:'middle',height: '56px'}" rowspan="2">
                  <div class="color-yellow" v-html="getPcustomerInfo(item)"></div>
                  <div>
                    <div v-html="getLiuYan(item.remark)"
                         style="text-align: left;padding-left: 5px;padding-right: 5px;" class="color-grey"></div>
                    <div style="height: 24px;" v-if="item.isEnd">
                      <span  class="pointer color-grey HideButton"
                            @click="showLiuYan(item)">我要留言</span></div>
                  </div>
                </td>
                <td rowspan="2" class="width_200 textCenter btnBox">
                  <div v-if="status=='all'&&!(item.status=='500'||item.status=='400'||item.status=='750')">
                    {{getStatusName(item)}}
                  </div>
                  <div v-if="(item.status=='500'||item.status=='400')&&item.isEnd" style="text-align: left;">
                    <span style="margin-left: 10px;">出库时间：{{item.handleoverdate}}</span>
                    <i style="display: block;height: 5px"></i>
                    <span style="margin-left: 10px;">操&nbsp;作&nbsp;&nbsp;人：{{item.handleoveruname}}</span>
                    <i style="display: block;height: 5px"></i>
                    <!--<span style="margin-left: 10px;">物流公司：{{item.logisticsco}}</span>-->
                    <!--<i style="display: block;height: 5px"></i>-->
                    <!--<span style="margin-left: 10px;">物流单号：{{item.logisticsnum}}</span>-->
                  </div>
                  <div v-if="item.status=='750'&&item.isEnd" style="text-align: left;">
                    <span style="margin-left: 10px;">办结时间：{{item.handleoverdate}}</span>
                    <i style="display: block;height: 5px"></i>
                    <span style="margin-left: 10px;">操&nbsp;作&nbsp;&nbsp;人：{{item.handleoveruname}}</span>
                    <i style="display: block;height: 5px"></i>
                  </div>
                  <button v-if="item.buyinfo" @click="lookbuyorderdetail(item,0)">查看采购单</button>
                  <button @click="lookDetails(item)" v-if="item.isEnd">查看订单</button>
                  <button @click="lookDetails(item,true)" v-if="item.isEnd">打印</button>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <!--contentTable end-->
      </div>
      <!--待确认end-->
    </div>
    <div class="foot">
      <Pagination ref="pagination1" @bindgrid="bindPagination" :pagination="pagination"
                  :layout="'total , prev, pager, next, jumper'"></Pagination>
    </div>
    <CstagreementEdit ref="DataContactEdit" @bindGrid="bindGrid('1','1')"></CstagreementEdit>
    <LiuYanEdit ref="liuyan" @afterLiuYan="afterLiuYan"></LiuYanEdit>
    <BuyorderDetail ref="BuyorderDetail"   @bindGrid="bindGrid('1','1')"></BuyorderDetail>
    <WriteFrameReturnOrder ref="WriteFrameReturnOrder" :filterbyservedserial="true" @bindGrid="bindGrid('1','1')"></WriteFrameReturnOrder>
  </div>
</template>

<script>
  import CstagreementEdit from './CstagreementEdit';
  import LiuYanEdit from './LiuYanEdit'
  import BuyorderDetail from '../buyagreement/BuyorderDetail';
  import WriteFrameReturnOrder from './WriteFrameReturnOrder'
  import AutoComplete from "../../common/AutoCustomer";

  import {getCstagreementListDataNew,updatejiagong } from '@/api/set/csagreement';
  import {independentDept} from '@/api/set/dept';
  import {computedResidualTime, getRemark} from '@/plugin/ordercommon'
  import {exportPdf} from '@/api/file'

  export default {
    name: 'CstagreementList',
    data() {
      return {
        printItem: {},
        userInfoModel: {},
        formtype: 42,
        statuses: "150,200,300,350,400,500,650,655,660,700,750",//多个状态，逗号隔开
        status: this.mystatus,
        id: '',
        fileuname: "",//加工人员
        itemtemp: {},//操作某条记录的临时变量
        countPageTotal:true,
        isShow: false,
        activeIndex: '100',
        searchContentHeight: 50,
        statusobj: [{value: "150,200,300,350,400,500,650,655,660,700,750", text: "全部"},
          {value: "200", text: "待确认"}, {value: "300", text: "待加工"}, {value: "350", text: "待发货"},
          {value: "500", text: "已发货"}, {value: "700", text: "待退款"}, {value: "750", text: "退款完成"},
          {value: "400", text: "待配送"}, {value: "150", text: "待选货"}, {value: "650", text: "退货客服岗待确认"}, {
            value: "655",
            text: "退货订单岗待确认"
          }, {value: "660", text: "退货仓库岗待确认"}],
        msg: '订单合并显示',
        dialogFormVisible: false,
        searchdata: "",
        independentserial: "",
        loading: true,
        categorycode: "",
        categoryname: "",
        seedcode: "",
        seedname: "",
        datetype: '10',//'10'表示按下单时间，'20'表示按发货时间
        searchdatevalue: [],//时间段选择
        unitgroup: "",//查询条件的选择供应商或者门店使用
        pcustomer: "",//供应商，仅仅作为显示使用
        pcustomerserial: '',
        customername: '',//门店，仅仅作为显示使用
        customerserial: '',
        cangkucode: '',
        noloading: false,//是否显示 加载中 锁屏
        pagination: {
          currentPage: 1,
          pageSize: 20,
          total: 0
        },
        tableData: [],
        logistics: [],
        idd: [],
        idd1: [],
        idd2: [],
        checkmodel: [],
        checkedAll: false,
        jxcstoreData: [],
        seedcodes: [],
        couriernumber: '',//快递单号条码
        tracknum: '',//供应商号,
        erpserials: '',//根据跟踪单号获得的销售单号
        hetongserial: '',//销售单号
      }
    },
    props: {
      mystatus: {
        default: '200'
      },
      roletype: {
        default: "" //角色菜单信息， 取值：order 、 buy、 store、machining、jiesuan、customerservice 、supply ， 分别对应订单、采购单、库存、加工、结算、客服、供应商利润  等菜单角色
      },
      shoudongcaigou: {//手动采购单用到  1未审核 2审核过
        default: ''
      }
    },
    methods: {
//加急、已退货图片展示
      picture(item) {
        if (item.isreturnorder&&item.isreturnorder == -1) {
          return {
            paddingRight: '0px',
            paddingLeft: '0px',
            background:  'url(/static/img/tuihuotip.png) no-repeat right center'
          }
        }
      },
      computedTime: function (game, endTime, overtime) {
        return computedResidualTime(game, endTime, overtime);
      },
      changePackageSize(PackagesizeList) {
        if(!PackagesizeList) return '';
        var pack = PackagesizeList.split(';')
        var packString = '';
        for (var i = 0; i < pack.length; i++) {
          if (pack[i] && pack[i] != ',') {
            if (pack[i].substr(0, 1) == ',') {
              pack[i] = pack[i].substr(1);
            }
            //console.log(pack[i])
            try {
              var ps = JSON.parse(pack[i]);
              var rl = '';
              if (ps.Y) {
                if (ps.type)
                  rl = ps.type + ',';
                packString += "（" + rl + 'S:' + ps.Y + ',C:' + ps.X + "）";
              } else {
                if (ps.M || ps.C) {
                  packString += "（" + ps.M + (ps.C ? '-' : '') + ps.C + "）";
                }
              }
            } catch (ex) {

            }
          }
          if (i == 3)//最多显示4个
            break;
        }
        return packString;
      },
      //查询条件的门店之后执行
      afterSelExternalDept(customerserial, customername, row) {
        this.customername = customername
        this.customerserial = customerserial
        this.bindGrid()
      },
      clearCustomerName() {
        // this.isClickEvent = false
        this.customername = ""
        this.customerserial = ""
        this.bindGrid()
      },
      show1: function (item) {
        item.isShow = true
      },
      hide1: function (item) {
        item.isShow = false
      },
      //加工单、销售单、拼好货、退货单
      getOrderType(item) {
        var showColor = '#909399';
        var ordername = '';

        if (item.formtype == 42) {
          ordername = item.yewutype
          if (item.parentguid) {
            ordername = '退货单'
            showColor = '#F56C6C'
          } else {
            if (item && item.jxcformdetailDOList && item.jxcformdetailDOList.length > 0) {
              for (let i in item.jxcformdetailDOList) {
                if (item.jxcformdetailDOList[i].filltemplate == "50") {
                  ordername = '加工单'
                }
              }
            }
          }
        }
        if (ordername == '加工单')
          showColor = 'red';
        if (item.voucherdetailguid) {
          ordername = '铺货-' + ordername;
          showColor = '#67C23A';
        }
        if (showColor)
          return "<span style='color:" + showColor + ";'><b>" + ordername + "</b></span>"
        return ordername
      },
      lookDetails(row, needprint) {
        row.openprint = needprint?true:false;
        this.$refs.DataContactEdit.initData(row)
        this.OpenDialog()
      },
      //查看采购单
      lookbuyorderdetail(row, isbuyorder) {
        this.$refs.BuyorderDetail.initData(row, isbuyorder, "", this.roletype)
        this.$refs.BuyorderDetail.show();
      },
      getLiuYan(remark) {
        return getRemark(remark);
      },
      showLiuYan(item, opmsg, status) {//留言
        this.$refs.liuyan.show(item, opmsg, status)
      },
      afterLiuYan(remark, unitguid, status, erpserial) {//留言
          this.tableData.forEach(item => {
            if (item.unitguid == unitguid) {
              item.remark = remark;
            }
          })
      },
      //镜架类下单
      showjingjiaOrderWeb() {
        this.$refs.WriteFrameReturnOrder.show(1, '门店下单')
      },
      getPcustomerInfo(item) {
        let result = "";
        if (item.pcustomerserial) {
          result = this.roletype == "customerservice" ? "" : "<span style='color:black;'>" + item.pcustomer + "</span>"
          if (item.buyinfo) {
            let temp = JSON.parse(item.buyinfo)
            if (temp.status == "810") {
              result += "<span style='color:black;'>采购中</span>"
            } else if (temp.status == "820") {
              result += "<span style='color:black;'>采购已完成</span>"
            }
          }
        } else {
          result = ''
        }
        return result
      },
      getStatusName(item) {
        for (let i in this.statusobj) {
          if (this.statusobj[i].value == item.status) {
            return this.statusobj[i].text
          }
        }
        return ""
      },
      search() {
        this.erpserials = ''
        this.tracknum = ''
        this.bindGrid();
      },
      bindPagination() {//分页不重新取总数
        this.countPageTotal = false;
        this.bindGrid()
      },
      bindGrid() {
        //根据跟踪号、供应商号搜索，不出发 发货来源条件
        this.pagination.pageSize = 30;
        var formData = {
          needtuihuoinfo: "1",
          offset: (this.pagination.currentPage - 1) * this.pagination.pageSize,
          limit: this.pagination.pageSize,
          search: this.hetongserial != '' ? '' : this.searchdata.trim(),
          status: this.statuses ? "" : this.status,
          statuses: this.statuses,
          formtype: this.formtype,
          seedcode: this.seedcode,
          categorycode: this.categorycode,
          independentserial: this.status == 'all' ? 'all' : this.independentserial,
          applybydserial: this.status == 'all' && this.independentserial != 'all' ? this.independentserial : '',
          customerserial: this.customerserial,
          pcustomerserial: this.pcustomerserial,
          needdetail: "1",
          isshowbuyinfo: "1",
          isshowstore: "0",
          isshowpayinfo: "1",
          isshowtuihuofrombuy: "0",
          neefahuoinfo: "1",
          isreturnorder: (this.status == 'all' && this.statuses.indexOf(',') > -1) ? '' : '-999',
          fileuname: this.fileuname,
          cangkucode: "",
          datetype: this.datetype,
          startdate: this.searchdatevalue && this.searchdatevalue.length > 0 ? this.searchdatevalue[0] : "",
          enddate: this.searchdatevalue && this.searchdatevalue.length > 0 ? this.searchdatevalue[1] + " 23:59:59" : "",
          erpserials: this.erpserials,
          tracknum: this.tracknum.trim(),
          iswriteorder: "",
          shoudongcaigou: "",//  手动采购 1未审核 2审核通过
          purchase: "",// 仓库岗待收货 用
          needtotal: "-1",//不计算记录总数
          mergeorder: "1"
        };

        this.tableData = []
        getCstagreementListDataNew(formData, this.noloading).then(response => {
          var rows = response.data.obj.rows
          if (this.countPageTotal) {

            formData.needtotal = "1";
            getCstagreementListDataNew(formData, true).then(response => {
              this.pagination.total = response.data.obj
            });

          } else this.countPageTotal = true;

          if (rows.length == 0) {
            return
          }
          //同一副镜架排序
          for (let i = 0; i < rows.length; i++) {
            if (rows[i].hasAdd) continue;

            rows[i].isFirst=true;
            this.tableData.push(rows[i]);
            var hasNext=false;
            for (let j = i + 1; j < rows.length; j++) {
              if (rows[j].hasAdd) continue;

              if (rows[j].groupguid == rows[i].groupguid&&rows[j].sellorderguid == rows[i].sellorderguid) {
                this.tableData.push(rows[j]);
                rows[j].hasAdd = true;
                hasNext=true;
              }
            }
            if(hasNext){//存在同组的订单
              this.tableData[this.tableData.length-1].isEnd=true;
            }else{
              rows[i].isEnd=true;
            }
            rows[i].hasAdd = true;
          }
        }).catch((error) => {
        });
      },
      OpenDialog() {
        this.$refs.DataContactEdit.yincangdayin()
        this.$refs.DataContactEdit.show()
      },
      getPackages(packages) {
        if (packages) {
          var pg = JSON.parse(packages);
          return (pg.type || '') + (pg.Y ? (pg.Y + '，') : '') + (pg.X || '')
        }
        return '';
      },
    },
    mounted() {
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      //默认值
      this.independentserial = "all";//this.userInfoModel.independentserial;

      var end = new Date();//当天
      var year=end.getFullYear();
      var month=end.getMonth()+1;
      this.searchdatevalue = [(month>6?(year + '-' + (month-6) ):((year - 1) + '-' + (6+month)))+ '-' + end.getDate(),
        year + '-' +month + '-' + end.getDate()];
      this.bindGrid();

      independentDept().then(response => {
        this.idd = response.data.obj
        if (this.userInfoModel.independentserial != "" && (this.roletype == "order" || this.roletype == 'customerservice')) {
          //此时是经销商账户登录，且是订单或者客服菜单进入，  需要在服务部门下拉框增加  总部 选项
          this.idd.unshift({serialnum: "", dname: this.userInfoModel.tenantname})
        }
        this.idd.unshift({serialnum: "all", dname: "全部"})
      })
    },
    components: {
      AutoComplete,
      LiuYanEdit,
      WriteFrameReturnOrder,
      BuyorderDetail,
      CstagreementEdit
    }

  }
</script>

<style scoped>

  @import '../../../../static/css/clear.css';
  @import '../../../../static/css/index.css';

  .orderTable {
    overflow: auto;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/testorder/cstagreement/CstagreementListMerge.vue